module.exports = __webpack_public_path__ + "static/media/m-player-close.01949be5.svg";